/* 
 * Filename:     
 * Website:      
 * Description:  
 * Author:       
 * */

import ngRoute from 'angular-route'
import ngAnimate from 'angular-animate'
import ngMessages from 'angular-messages'
import ngValidate from '../ngValidate'
import bsLoadingOverlay from 'angular-loading-overlay'
import ngMap from 'ngmap'
import ngVue from 'ngVue'
import angucompleteAlt from 'angucomplete-alt'

import accountCtrl from './Controllers/01.account.ctrl';
import accountshippingCtrl from './Controllers/02.account.shipping.ctrl';
import accountWishlistCtrl from './Controllers/03.account.wishlist.ctrl';
import cartCtrl from './Controllers/04.cart.ctrl';
import checkoutCtrl from './Controllers/05.checkout.ctrl';
import checkoutDeliveryDetailsCtrl from './Controllers/06.checkout.delivery.details.ctrl';
import checkoutOrderDetailsCtrl from './Controllers/07.checkout.order.details.ctrl';
import checkoutGiftsCtrl from './Controllers/18.checkout.gifts.ctrl'
import productListCtrl from './Controllers/08.products.list.ctrl';
import productInnerCtrl from './Controllers/09.products.inner.ctrl';
import mapController from './Controllers/10.map.ctrl';
import mobileMenuCtrl from './Controllers/11.mobile.menu.ctrl';
import newsletterAdvCtrl from './Controllers/17.newsletterAdv.ctrl';
import talkToUsCtrl from './Controllers/13.talkToUs.ctrl';
import customHatForm from './Controllers/14.customHatForm.ctrl';
import productSearchCtrl from './Controllers/15.product.search.ctrl';
import passwordResetCtrl from './Controllers/16.passwordReset.ctrl';

var app = angular
    .module("eshopApp", ["ngRoute", "ngAnimate", "ngMessages", "ngValidate", "bsLoadingOverlay", "ngMap", "mobileMenu", "ngVue", "angucomplete-alt"])

    .controller('accountCtrl', accountCtrl)
    .controller('accountshippingCtrl', accountshippingCtrl)
    .controller('accountWishlistCtrl', accountWishlistCtrl)

    .controller('cartCtrl', cartCtrl)
    .controller('checkoutCtrl', checkoutCtrl)
    .controller('checkoutDeliveryDetailsCtrl', checkoutDeliveryDetailsCtrl)
    .controller('checkoutOrderDetailsCtrl', checkoutOrderDetailsCtrl)
    .controller('checkoutGiftsCtrl', checkoutGiftsCtrl)

    .controller('productListCtrl', productListCtrl)
    .controller('productInnerCtrl', productInnerCtrl)

    .controller('mapController', mapController)
    .controller('mobileMenuCtrl', mobileMenuCtrl)
    .controller('newsletterAdvCtrl', newsletterAdvCtrl)
    .controller('talkToUsCtrl', talkToUsCtrl)
    .controller('customHatForm', customHatForm)

    .controller('productSearchCtrl', productSearchCtrl)
    .controller('passwordResetCtrl', passwordResetCtrl);
/*
|--------------------------------------------------------------------------
| App Configuration
|--------------------------------------------------------------------------
|
|
 */
app.config(['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol("{{");
    $interpolateProvider.endSymbol("}}");
}]);

/*
|--------------------------------------------------------------------------
| App Run
|--------------------------------------------------------------------------
|
|
 */
app.run(["$http", "$rootScope", "bsLoadingOverlayService", "$compile", "$filter", function ($http, $rootScope, bsLoadingOverlayService, $compile, $filter) {

    //Define on header that request comes from ajax
    $http.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
    $rootScope.params = function (params) {
        params._token = window.Laravel.csrfToken;
        return $.param(params);
    }

    $rootScope.path = window.location.pathname;

    bsLoadingOverlayService.setGlobalConfig({
        delay: 500,
        templateUrl: '/helpers/get/loader'
    });

    $rootScope.showOverlay = function (referenceId) {
        bsLoadingOverlayService.start({
            referenceId: referenceId
        });
    };

    $rootScope.hideOverlay = function (referenceId) {
        bsLoadingOverlayService.stop({
            referenceId: referenceId
        });
    }

    $rootScope.wishlist = [];

    $rootScope.fancyboxInlineOptions = {
        toolbar: false,
        smallBtn: true,
        trapFocus: false,
        touch: false,
        clickOutside: false,
        btnTpl: {
            arrowLeft: `
            <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
                <i class="icon-arrow-left"></i>
            </button>
            `,
            arrowRight: `
            <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
                <i class="icon-arrow-right"></i>
            </button>
            `,
            smallBtn: `
            <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                <i class="icon-close"></i>
            </button>
            `,
        },
        beforeLoad: function (instance, slide) {
            if (slide.$slide[0].attributes["data-fancybox-class"]) {
                $(instance.$refs.container[0]).addClass(
                    instance.$lastFocus[0].attributes["data-fancybox-class"].value
                );
            }
        },
        afterClose: function () {
            try {
                $scope.responses.registerForm.success = false;
            } catch (e) {

            }
        }
    };

    $rootScope.getsession = function () {
        $http({
            method: "GET",
            url: "/en/cart",
            data: $rootScope.params([]),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function success(successResponse) {
            $rootScope.session = successResponse.data;
        }, function error(errorResonse) {
            $rootScope.session_error = errorResonse.data;

        });
    };

    $rootScope.$data = {};

    // sampleProductObj = {
    //     name: '',
    //     id: '',
    //     price: '',
    //     brand: '',
    //     cat: '',
    //     variant: '',
    //     position: '',
    //     url: '',
    // };
    $rootScope.productClick = function (productObj) {
        dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': {
                        'list': 'Search Results'
                    }, // Optional list property.
                    'products': [{
                        'name': productObj.name, // Name or ID is required.
                        'id': productObj.id,
                        'price': productObj.price,
                        'brand': productObj.brand,
                        'category': productObj.cat,
                        'variant': productObj.variant,
                        'position': productObj.position
                    }]
                }
            },
            'eventCallback': function () {
                document.location = productObj.url
            }
        });
    }

}]);

/*
|--------------------------------------------------------------------------
| Vue Components
|--------------------------------------------------------------------------
|
|
 */
import CookiesAdvanced from '../components/cookies-advanced/cookies-advanced.vue'
app.value('CookiesAdvanced', CookiesAdvanced);

import BgVideo from '../components/bg-video/index.vue'
app.value('BgVideo', BgVideo);

import stripe from '../components/stripe/index.vue'
app.value('stripe', stripe);

/*
|--------------------------------------------------------------------------
| App Filters
|--------------------------------------------------------------------------
|
|
 */
app.filter('rootcurrency', function () {
    return function (input, place, symbol) {
        if (isNaN(input)) {
            return input;
        } else {
            var symbol = symbol || '€';
            var place = place === undefined ? 'right' : 'left';
            input = input.toFixed(2);
            if (place === 'left') {
                return symbol + input;
            } else {
                return input + ' ' + symbol;
            }
        }
    }
})

app.filter('brackets', function () {
    return function (input) {
        var re = /{(.*)}/;
        var output = input.match(re);
        return output[1];
    }
});

app.filter('page', function () {
    return function (input) {
        if (input) {
            path = input.replace("/en/", "");
            path = path.replace(".php", "");
            if (path == "") {
                return "main";
            } else {
                return path;
            }
        }
    }
});

app.filter("stokoiFilter", function () {
    return function (items, match) {
        var returnArray = [];
        var matching = [],
            matches, falsely = true;
        try {
            if (!!match.destination) {
                angular.forEach(items, function (item) { // e.g. { title: "ball" }
                    matches = true;
                    angular.forEach(match, function (value, key) { // e.g. 'all', 'title'
                        if (!!value) { // do not compare if value is empty
                            var matcher = new RegExp("\b" + value, "i");
                            matches = matches && matcher.test(item[key]);
                        }
                    });
                    if (matches) {
                        matching.push(item);
                    }
                });
            }
            return matching;
        } catch (e) { }
    }
})

app.filter("stokoiFilter", function () {
    return function (items, match, scope) {
        var matching = [],
            matches, matchesCountry, matchesOnline, falsely = true;
        angular.forEach(match, function (value, key) {
            falsely = falsely && !value;
        });
        if (falsely) {
            return items;
        }
        angular.forEach(items, function (item) {
            matches = matchesCountry = matchesOnline = true;
            if (!!match.country && match.country !== 'ALL COUNTRIES') {
                if (match.country == item.country) {
                    matchesCountry = true;
                } else {
                    matchesCountry = false;
                }
            }
            if (!!match.online) {
                if (match.online == item.online) {
                    matchesOnline = true;
                } else {
                    matchesOnline = false;
                }
            }
            matches = matches && matchesCountry && matchesOnline;

            if (matches) {
                matching.push(item);
            }
        });

        return matching;
    }
});

/*
|--------------------------------------------------------------------------
| App Directives
|--------------------------------------------------------------------------
|
|
 */

app.directive("onRepeatEnd", function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            // try{
            //   $('#product-slider').slick("unslick");
            //   $('#product-carousel').slick("unslick");
            // }catch(e){
            // }
            // productSlider();
        }
    };
});

app.directive("validateFocusOnFirst", function () {
    return {
        restrict: "A",
        link: function (scope, elem) {
            elem.on("submit", function () {
                console.log('elem: ', elem);

            });
        }
    };
});

app.directive('toNumbers', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

app.directive("stringToNumber", function () {
    return {
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                return "" + value;
            });
            ngModel.$formatters.push(function (value) {
                return parseFloat(value, 10);
            });
        }
    };
});

app.directive("convertToNumber", function () {
    return {
        require: "ngModel",
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return val != null ? parseInt(val, 10) : null;
            });
            ngModel.$formatters.push(function (val) {
                return val != null ? "" + val : null;
            });
        }
    };
});

app.directive("fileread", function () {
    return {
        scope: {
            fileread: "=",
            valid: '='
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                scope.valid = true

                var sizeLimit = attributes.maxSize
                var fileSize = element[0].files[0].size

                if (fileSize < sizeLimit) {
                    var label = element[0].value.split('\\')
                    scope.$apply(function () {
                        scope.valid = true
                        scope.fileread = label[label.length - 1]
                    })
                } else {
                    element[0].value = ""

                    scope.$apply(function () {
                        scope.valid = false
                        scope.fileread = ''
                    })
                }

                // reader.onload = function (loadEvent) {
                //     scope.$apply(function () {
                //         scope.fileread = loadEvent.target.result;
                //     });
                // }
                // reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    }
});

app.directive('ngFile', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('change', function () {
                $parse(attrs.ngFile).assign(scope, element[0].files)
                scope.$apply();
            });
        }
    };
}]);


function alterGETparam(param, value) {
    var newURL = updateURLParameter(window.location.href, param, value);
    newURL = updateURLParameter(newURL, param, value);
    window.history.replaceState('', '', updateURLParameter(window.location.href, param, value));
}

function updateURLParameter(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
        if (TheAnchor)
            additionalURL = TheParams;

        tempArray = additionalURL.split("&");

        for (var i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    } else {
        var tmpAnchor = baseURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];

        if (TheParams)
            baseURL = TheParams;
    }

    if (TheAnchor)
        paramVal += "#" + TheAnchor;

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
}

/*
|--------------------------------------------------------------------------
| $ On Document Ready
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
$(function () {
    /**
     * CART
     */
    initCart();
});

/*
|--------------------------------------------------------------------------
| CART
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
function initCart() {

    $("#cart .managequantity").on("click", function (e) {
        //debugger;
        var q = $(this).data("quantity");
        var curVal = $(this)
            .siblings(".cart-prod-quantity")
            .text();
        var val = 0;

        if (q == "decrease") {
            val = -1;
        } else if (q == "increase") {
            val = 1;
        } else {
            val = 0;
        }

        if (parseInt(curVal) == 1 && q == "decrease") {
            val = 0;
        }

        e.preventDefault();
        if (!$(this).hasClass("disabled")) manageQuantity($(this), val);

    });

    $("#cart").delegate(".quantity-cart", "blur", function () {
        var available = $(this)
            .closest(".bag-item")
            .data("available");
        var currentqty = parseInt($(this).data("currentqty"));
        var newqty = parseInt($(this).val());

        if (isNaN(newqty)) {
            $(this).val(currentqty);
        } else {
            if (currentqty != newqty) {
                if (newqty > available) {
                    $(this).val(available);
                } else if (newqty <= 0) {
                    $(this).val(1);
                }
                var newqty = parseInt($(this).val());
                if (currentqty != newqty) {
                    manageQuantity($(this), newqty - currentqty);
                }
            }
        }
    });

    $("#cart .add-to-wishlist").click(function (e) {
        e.preventDefault();
        //var variant = $(".variant-filter button.active").data('variantid');
        var variant = $(this).data("variant");
        var notification = $(this).data("notification");
        var thisObj = $(this).parent();

        if (typeof variant == "undefined") {
            displayMessageCart("selectSize", true, thisObj);
        } else {
            var jsonData = {
                action: "addtowishlist",
                variantid: variant
            };
            if (notification) {
                jsonData.notification = 1;
            }

            // $.ajax({
            //     url: "/actions.php",
            //     data: jsonData,
            //     dataType: "json",
            //     success: function (result) {

            //         if (notification && result.success >= 0) {
            //             displayTimedMessageCart("notifySuccess", 6000, thisObj);
            //         } else {
            //             if (result.success > 0) {
            //                 displayTimedMessageCart("addedToWishlist", 6000, thisObj);
            //             } else if (result.success == 0) {
            //                 displayTimedMessageCart("alreadyInWishlist", 6000, thisObj);
            //             } else if (result.success == -1) {
            //                 displayTimedMessageCart("notLoggedIn", 6000, thisObj);
            //             }
            //         }
            //     }
            // });
        }
    });

    $(".removeFromCart").click(function (e) {
        e.preventDefault();
        manageQuantity($(this), 0);
    });

    $(".summaries").delegate(".checkout.disabled", "click", function () {
        displayMessage("wholesaleMinimum", true);
    });
}

function toggleTopCallback() {
    // $.get('/ajax/cart.php?raw=1', function (data) {
    //     $('#cart .loadingContent').fadeOut(function () {
    //         $('#cart .loadedContent').html(data).fadeIn();
    //         initCart();
    //     })
    // });
}

function manageQuantity(elem, addqty) {
    var oiid = $(elem)
        .closest("tr")
        .data("oiid");
    // $.ajax({
    //     url: "/actions.php",
    //     data: {
    //         action: "managequantity",
    //         oiid: oiid,
    //         addqty: addqty
    //     },
    //     dataType: "json",
    //     success: function (result) {
    //         parseBasketValues(result);
    //         itemAdditionCallback(result, addqty, oiid);
    //         $rootScope = angular.element('body').scope().$root
    //         $rootScope.getsession();
    //         $rootScope.$apply();
    //     }
    // });
}

function itemAdditionCallback(result, addqty, oiid) {
    var currentQty = parseInt(
        $("#cart tr[data-oiid='" + oiid + "'] .cart-prod-quantity").text()
    );
    var newQty = currentQty + addqty;
    var listItem = $("#cart tr[data-oiid='" + oiid + "']");

    $(listItem)
        .find(".cart-prod-quantity")
        .text(newQty);

    if (result.item_price !== false)
        $(listItem)
            .find(".itemPrice")
            .text(result.item_price);

    if (addqty == 0) {
        //debugger;
        $(listItem).fadeOut("fast", function () {
            $(this).remove();
            if ($("#cart .table-cart.cart-items tr").length < 1) {
                $("#cart #withItems").fadeOut("fast", function () {
                    $("#noItems").fadeIn("fast");
                });
            }
        });
    } else {
        var qty = $(listItem)
            .find(".quantity-cart")
            .val();

        if (qty >= $(listItem).data("available")) {
            $(listItem)
                .find(".addQty")
                .addClass("disabled");
        } else {
            $(listItem)
                .find(".addQty")
                .removeClass("disabled");
        }
        if (qty <= 1) {
            $(listItem)
                .find(".removeQty")
                .addClass("disabled");
        } else {
            $(listItem)
                .find(".removeQty")
                .removeClass("disabled");
        }
    }
    if (result.checkout_enabled) {
        displayMessage("wholesaleMinimum", false);
        $(".checkout").removeClass("disabled");
    } else {
        displayMessage("wholesaleMinimum", true);
        $(".checkout").addClass("disabled");
    }
    showLastItems();

    if (typeof result.items != "undefined") {
        //$(".btn-cart.total-product-quantity span").text(result.items);
    } else {
        //$(".btn-cart.total-product-quantity span").text(result.total_items);
    }

    toggleTopCallback();
}

function submitCallback() {
    parent.location.reload();
}

function showLastItems() {
    //$("#cart tbody tr").each(function () {
    $("#cart .bag-item").each(function () {
        if ($(this).data("available") == $(this).find(".quantity-cart").val()) {
            $(this).find(".lastItem:hidden").fadeIn("fast");
        } else {
            $(this).find(".lastItem:visible").fadeOut("fast");
        }
    });
}

function displayTimedMessageCart(msgNumber, time, context) {
    displayMessageCart(msgNumber, true, context);
    setTimeout(function () {
        displayMessageCart(msgNumber, false, context);
    }, time);
}

function displayMessageCart(msgNumber, showError, context) {
    var elem = context.find(" .msg-" + msgNumber);
    if (showError) {
        if (elem.is(":hidden")) {
            elem.fadeIn("fast");
        } else {
            animateElement(elem);
        }
    } else {
        elem.fadeOut("fast");
    }
}

function displayTimedMessage(msgNumber, time) {
    displayMessage(msgNumber, true);
    setTimeout(function () {
        displayMessage(msgNumber, false);
    }, time);
}

function displayMessage(msgNumber, showError) {
    var elem = $(".msg-" + msgNumber);
    if (showError) {
        if (elem.is(":hidden")) {
            elem.fadeIn("fast");
        } else {
            animateElement(elem);
        }
    } else {
        elem.fadeOut("fast");
    }
}

function animateElement(elem) {
    var animationStyle = "animated shake";
    var animationEnd =
        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
    elem.addClass(animationStyle).one(animationEnd, function () {
        $(this).removeClass(animationStyle);
    });
}

function adjustRegions(container, cid) {

    if (cid) {
        // $.ajax({
        //     url: "/actions.php",
        //     method: "post",
        //     data: {
        //         action: "getcountryregions",
        //         country_id: cid
        //     },
        //     dataType: "json",
        //     complete: function (result) {
        //         $('.region-container.dropdown').unbind('click');
        //         var data = result.responseJSON;
        //         container.find('.region-container .dropdown-choices').html('<span data-value="0">-</span>');
        //         $.each(data, function (i, o) {
        //             container.find('.region-container .dropdown-choices').append('<span data-value="' + o.region_id + '">' + o.name + '</span>');
        //         });
        //         dropdown('.region-container');
        //         //
        //     }
        // });
    }
}

function changeAddress(container) {
    var addr = container;
    countrySelect.val(addr.data("cid"));
}

function parseBasketValues(result) {
    //SUMMARY
    $(".subTotalVal").text(result.subTotal);
    $(".vatVal").text(result.vat);
    $(".weight").text(result.weight);
    $(".shippingVal").text(result.shipping);
    $(".discountVal").text(result.discount);
    $(".totalVal, #sumTotal").text(result.total);

    if (parseFloat(result.discount.replace(",", ".")) != 0)
        $("#discountContainer").show();
    else if (parseFloat(result.shipping.replace(",", ".")) != 0) {
        //$("#discountContainer").hide();

        $(".freeShip").hide();
        $(".payShip").show();
    } else {
        $(".freeShip").show();
        $(".payShip").hide();
    }

    //HEADER
    $("#sumItems").text(result.total_items);
    $("#sumTotal").text(result.total_no_extras);

    //Cart
    if ($(".totalItems").length > 0) $(".totalItems").text(result.total_items);

    try {
        $(".nowFreeShipping").hide();
        $(".overLimitFreeShipping").hide();

        if (result.total_no_extras >= 60) {
            $(".nowFreeShipping").show();
        } else {
            $(".overLimitFreeShipping").show();
        }
    } catch (e) { }
}

/*
|--------------------------------------------------------------------------
| PRODUCT DETAILS
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
function initProduct() {
    $(".add-to-cart").click(function (e) {
        e.preventDefault();
        var selectedProduct = $("select.variant-filter option:selected");
        var variant = selectedProduct.data("variantid");
        var pageid = selectedProduct.data("productid");
        var price = selectedProduct.data("price");
        var code = selectedProduct.data("code");
        var isDisabled = selectedProduct.hasClass("disabled");
        $("select.variant-filter").removeClass("hasError");
        if (isDisabled) {
            if (!variant) {
                displayMessage("selectSize", true);
                $("select.variant-filter")
                    .focus()
                    .addClass("hasError");
            } else {
                $(".msg").fadeOut("fast");
                displayMessage("outOfStock", true);
            }
        } else {
            $(".add-to-cart").addClass('loading');
            // $.ajax({
            //     url: "/actions.php",
            //     data: {
            //         action: "additem",
            //         variant: variant,
            //         pageid: pageid
            //     },
            //     dataType: "json",
            //     success: function (result) {
            //         itemAdditionCallback(result);
            //         $(".add-to-cart").removeClass('loading');
            //     }
            // });
        }
    });

    $(".add-to-wishlist").click(function (e) {
        e.preventDefault();
        var selectedProduct = $("select.variant-filter option:selected");
        var variant = selectedProduct.data("variantid");
        var productid = selectedProduct.data("productid");
        var notification = $(this).data("notification");

        if (typeof variant == "undefined" || variant == "") {
            displayMessage("selectSize", true);
        } else {
            var jsonData = {
                action: "addtowishlist",
                variantid: variant,
                productid: productid
            };
            if (notification) {
                jsonData.notification = 1;
            }
            // $.ajax({
            //     url: "/actions.php",
            //     data: jsonData,
            //     dataType: "json",
            //     success: function (result) {
            //         if (notification && result.success >= 0) {
            //             displayTimedMessage("notifySuccess", 6000);
            //         } else {
            //             if (result.success > 0) {
            //                 displayTimedMessage("addedToWishlist", 6000);
            //             } else if (result.success == 0) {
            //                 displayTimedMessage("alreadyInWishlist", 6000);
            //             } else if (result.success == -1) {
            //                 displayTimedMessage("notLoggedIn", 6000);
            //             }
            //         }
            //     }
            // });
        }
    });
}


/*
|--------------------------------------------------------------------------
| CHECKOUT ORDER DETAILS - STEP 2
|--------------------------------------------------------------------------
|
| 
| 
| 
*/
$(document).ready(function () {
    var syncItemsInterval = 1 * 60 * 60; //1 minute

    //setTimeout(syncCartItems(), syncItemsInterval);

    showLastItems();

});

function syncCartItems() {
    // setInterval(function () {
    //     $.ajax({
    //         url: '/actions.php?action=synchronize-cart',
    //         success: function (result) {
    //             if (result == 'changed') {
    //                 location.reload();
    //             }
    //         }
    //     });
    // }, syncItemsInterval);
}

function recalculateTotals(costName, add) {
    // $.ajax({
    //     url: 'actions.php',
    //     method: 'POST',
    //     data: {
    //         action: 'changeextracosts',
    //         costName: costName,
    //         add: add
    //     },
    //     dataType: 'json',
    //     success: function (result) {
    //         parseBasketValues(result);
    //         if (add) {
    //             $("#" + costName + "Container").fadeIn("fast");
    //         } else {
    //             $("#" + costName + "Container").fadeOut("fast");
    //         }

    //     }
    // });
}

function changeShipping() {
    // $.ajax({
    //     url: '/actions.php',
    //     method: 'POST',
    //     data: {
    //         action: 'change-shipping',
    //     },
    //     dataType: 'json',
    //     success: function (result) {
    //         parseBasketValues(result);

    //     }
    // });
}